import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { handleError } from '@/utils/error'

import {
  addToList,
  createList,
  deleteList,
  editList,
  moveItemsToOtherList,
  removeItemsFromList,
} from '../service'

export const useListMutations = () => {
  const queryClient = useQueryClient()
  const toast = useToast()

  const addToListMutation = useMutation(addToList)
  const createListMutation = useMutation(createList, {
    onSuccess: () => {
      toast.success('List created successfully')
      queryClient.invalidateQueries('lists')
    },
    onError: (error) => {
      handleError(error, 'Error creating list')
    },
  })
  const editListMutation = useMutation(editList, {
    onSuccess: (_data, { id }) => {
      toast.success('List updated successfully')
      queryClient.setQueryData(['list', String(id)], _data)
      queryClient.invalidateQueries('lists')
    },
    onError: (error) => {
      handleError(error, 'Error updating list')
    },
  })
  const deleteListMutation = useMutation(deleteList, {
    onSuccess: () => {
      toast.success('List deleted successfully')
      queryClient.invalidateQueries('lists')
    },
    onError: (error) => {
      handleError(error, 'Error deleting list')
    },
  })
  const moveItemsToOtherListMutation = useMutation(moveItemsToOtherList, {
    onSuccess: (_data, { fromListId, toListId }) => {
      toast.success('Items moved successfully')
      queryClient.invalidateQueries('lists')
      queryClient.invalidateQueries(['list', String(fromListId)])
      queryClient.invalidateQueries(['list', String(toListId)])
    },
    onError: (error) => {
      handleError(error, 'Error moving items')
    },
  })

  const removeItemsFromListMutation = useMutation(removeItemsFromList, {
    onSuccess: (_data, { listId }) => {
      toast.success('Items removed successfully')

      queryClient.invalidateQueries(['list', String(listId)])
    },
    onError: (error) => {
      handleError(error, 'Error removing items')
    },
  })

  return {
    addToList: addToListMutation,
    removeItemsFromList: removeItemsFromListMutation,
    createList: createListMutation,
    editList: editListMutation,
    deleteList: deleteListMutation,
    moveItemsToOtherList: moveItemsToOtherListMutation,
  }
}
